import { type OpenApiSchemaImportPricesSettings } from '../../api/schema';
import { type IntegrationSettings, type SupportedIntegrationSyncTypes } from './types';

export const isIntegrationSettingsForPrices = (
    syncType: SupportedIntegrationSyncTypes,
    data: IntegrationSettings | undefined
): data is OpenApiSchemaImportPricesSettings => Boolean(data && syncType === 'prices');
